import Action from "./action";

class CartDiscountAction extends Action {
  type = "cart.discount";

  removalCode = "REMOVE_DISCOUNT_CODES"

  /**
   * Constructor
   * @param {Object} config 
   */
  constructor(config = {}) {
    super(config);
  }

  /**
   * Execute the action
   * @param {Object} data 
   */
  async execute(data) {
    this.log = [];
    console.groupCollapsed(this.logPrefix);
    console.log('Executing', this.config);
    console.log('Data', data);

    let result = true;

    console.log('Existing code:', Cookies.get("discount_code"));
    // @ts-ignore
    if(Cookies.get("discount_code") == this.config.discount.code) {
      this.addLog(true, "Code already applied", "⚠️");
      console.log('Ignore, code already applied');
    } else {
      // @ts-ignore
      Cookies.set('discount_code', this.config.discount.code, { expires: 7, path: '/' });
      console.log('Set code!');
      //document.cookie = `discount_code=${this.config.discount.code}; path=/`;
      let response = await fetch(`/discount/${this.config.discount.code}`);

      this.addLog(true, "Applied discount code");
      // @ts-ignore
      result = await MP.Extensions.Cart.fetchAndRenderMinicart();
    }

    console.groupEnd();
    return result;
  }

  /**
   * Undo the action
   * @param {Object} data 
   */
  async undo(data) {
    this.log = [];
    if(Cookies.get("discount_code") != this.config.discount.code) {
      console.log('code already something else, leave it')
      this.addLog(true, "Won't undo, code isn't ours", "⚠️");
      return;
    }
    console.log(`Changing the code from ${Cookies.get("discount_code")} to ${this.removalCode}`);

    this.addLog(true, "Removed discount code", "", "undo");
    // @ts-ignore
    Cookies.remove('discount_code');

    await fetch(`/discount/${this.removalCode}`);
    // @ts-ignore
    return await MP.Extensions.Cart.fetchAndRenderMinicart();
  }

  explainAction() {
    return `Apply ${MP.Logger.code(this.config.discount.code)}`;
  }

  explainUndo() {
    if(this.config.bidirectional){
      return `Remove discount code ${MP.Logger.code(this.config.discount.code)}`;
    }
  }
}

export default CartDiscountAction;